import {
    USER_CHOOSE_CURRENT_FRUI_QPFJ,
} from './constants';
  
export function chooseCurrentFrui_qpfj(modal) {
    return {
      type: USER_CHOOSE_CURRENT_FRUI_QPFJ,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case USER_CHOOSE_CURRENT_FRUI_QPFJ:
        return {
          ...state,
          currentFrui_qpfj:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/user/redux/chooseCurrentFrui_qpfj.js